import { render, staticRenderFns } from "./VideoCallGrid.vue?vue&type=template&id=55bc7d67&"
import script from "./VideoCallGrid.vue?vue&type=script&lang=js&"
export * from "./VideoCallGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports